import React from "react";
import { Monitor, Smartphone, ArrowLeftRight, Database, Cloud, Wrench, ArrowUpRight } from "lucide-react";

const services = [
  { icon: Monitor, name: "Web Development", text: "Custom websites, dashboards, admin panels, portals, CRM/ERP modules and web apps tailored to your business.", tags: ["Angular", "React", ".NET"] },
  { icon: Smartphone, name: "Mobile App Development", text: "Cross-platform Android & iOS apps using React Native with smooth UX and scalable backend integration.", tags: ["React Native", "iOS", "Android"] },
  { icon: ArrowLeftRight, name: "Backend & API Development", text: "Robust REST APIs using .NET / .NET Core with authentication, role-based access, and integration-ready design.", tags: [".NET Core", "REST", "Auth"] },
  { icon: Database, name: "Database Solutions", text: "SQL Server, PostgreSQL and Firebase (Firestore/Realtime) database design, optimization and data management.", tags: ["SQL Server", "Postgres", "Firebase"] },
  { icon: Cloud, name: "Hosting & Deployment", text: "Domain/DNS/SSL setup, cloud hosting, server deployment, CI/CD guidance and production monitoring.", tags: ["DNS", "SSL", "CI/CD"] },
  { icon: Wrench, name: "Maintenance & Support", text: "Ongoing maintenance, feature upgrades, security patches and performance tuning for long-term reliability.", tags: ["Upgrades", "Patches", "Tuning"] },
];

export const Services = () => {
  return (
    <section id="services" className="relative bg-[#070b18] py-24 overflow-hidden">
      <div className="absolute -top-20 right-1/4 w-[460px] h-[460px] rounded-full bg-violet-700/10 blur-[130px]" />
      <div className="relative max-w-6xl mx-auto px-4">
        <div className="text-center mb-14 max-w-2xl mx-auto">
          <span className="eyebrow reveal">What We Do</span>
          <h2 className="reveal d1 mt-5 font-display text-white text-3xl md:text-5xl">
            End-to-end <span className="text-gradient">services</span>
          </h2>
          <p className="reveal d2 mt-4 text-slate-400 text-base md:text-lg">
            From the first line of code to production hosting and support — we
            cover the entire product lifecycle.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, i) => {
            const Icon = s.icon;
            return (
              <div
                key={s.name}
                className={`reveal d${(i % 3) + 1} glow-card group relative rounded-3xl p-8 glass hover:-translate-y-1.5 transition-all duration-300`}
              >
                <span className="absolute top-6 right-7 font-display text-5xl text-white/5 group-hover:text-white/10 transition">
                  0{i + 1}
                </span>

                <div className="h-14 w-14 rounded-2xl bg-white/5 border border-white/10 grid place-items-center mb-6 group-hover:border-blue-400/40 transition">
                  <Icon className="h-7 w-7 text-blue-400 group-hover:scale-110 transition" strokeWidth={2.3} />
                </div>

                <h3 className="text-lg font-extrabold text-white flex items-center gap-2">
                  {s.name}
                  <ArrowUpRight className="h-4 w-4 text-blue-400 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition" />
                </h3>
                <p className="mt-3 text-slate-400 leading-relaxed">{s.text}</p>

                <div className="mt-5 flex flex-wrap gap-2">
                  {s.tags.map((t) => (
                    <span key={t} className="text-xs font-bold text-slate-300 px-2.5 py-1 rounded-full bg-white/5 border border-white/10">
                      {t}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
